import { useState } from 'react'
import { connect } from 'formik'
import { Modal } from 'shared'

export const MonthlyMatchingFundBanner = connect(({ formik, config, display }) => {
  if (config.receiverType === 'FundraisingEvent') return null
  if (!display.monthlyMatchingFundBanner) return null

  let bannerText = ''
  const [show, setShow] = useState(false)

  const handleClick = () => {
    setShow(true)
    document.activeElement.blur()
  }

  const onHide = () => setShow(false)

  if (formik.values.interval === 'monthly') {
    bannerText = I18n.t('donate.monthly_matching_fund_banner_monthly_html')
  } else {
    bannerText = I18n.t('donate.monthly_matching_fund_banner_html')
  }

  return <div className='matching-funds-monthly-donation-form-banner flex items-center'>
    <div className='ml-1'>
      <span dangerouslySetInnerHTML={{ __html: bannerText }} />
      <a onClick={handleClick} style={{ fontWeight: 'normal', marginLeft: '4px' }}><u>{I18n.t('donate.learn_more')}</u></a>
    </div>
    <Modal
      show={show}
      onHide={onHide}
      header={I18n.t('donate.monthly_matching_fund_banner_modal_header')}
      content={<span dangerouslySetInnerHTML={{ __html: I18n.t('donate.monthly_matching_fund_banner_modal_content_html') }} />}
    />
  </div>
})
